/**
 * @typedef {Object} FlicChatCommand
 * @property {string} name
 * @property {Object} params
 */

/**
 * Static class to manage the SDK.
 */
class SDKManager {
  constructor(socket, logger) {
    this.logger = logger;
    this.socket = socket;
    this.pendingCommands = [];
    this._eventListeners = [];
  }

  setOnline(isOnline = true) {
    this.socket.onceSubscribed(() => {
      const status = (isOnline ? 'online:' : 'offline:') + new Date().toISOString();
      this.socket.emit(MessageTypes.UPDATE_STATUS, {userData: { status }});
    });
  }

  openDirectConversation(contactInternalId) {
    const command = {
      name: 'open_conversation',
      params: {
        contactInternalId,
      },
    };
    this.pendingCommands = [...this.pendingCommands, command];
    this._eventListeners.forEach(listener => listener(command));
  }

  openChannel(channelName) {
    const command = {
      name: 'open_channel',
      params: {
        channelName,
      }
    };
    this.pendingCommands = [...this.pendingCommands, command];
    this._eventListeners.forEach(listener => listener(command));
  }

  openVideoCall(contactInternalId) {
    const command = {
      name: 'open_video_call',
      params: {
        contactInternalId
      }
    };
    this.pendingCommands = [...this.pendingCommands, command];
    this._eventListeners.forEach(listener => listener(command));
  }

  /**
   * Performs a command using callback and remove its from the command queue, if it exists
   * @param {FlicChatCommand} command
   * @param {Function} callback
   */
  executeCommand(command, callback) {
    callback(command);
    this.pendingCommands = this.pendingCommands.filter(c => c !== command);
  }

  /**
   * Called when any command is added through the other SDK methods
   * Possible commands: 'open_conversation' (params: internal_id)
   */
  addEventListener(callback) {
    this._eventListeners = [...this._eventListeners, callback];
    this.logger.log(
      `FCManager added event listener (total ${this._eventListeners.length})`,
    );
  }

  removeEventListener(callback) {
    this._eventListeners = this._eventListeners.filter(c => c !== callback);
    this.logger.log(
      `FCManager removed event listener (total ${this._eventListeners.length})`,
    );
  }
}

module.exports = SDKManager;



// WEBPACK FOOTER //
// ../node_modules/@flic-chat/js-sdk/src/sdk-manager.js